import { Link } from 'react-router-dom'
import styled from "styled-components"
import { isWhiteLabel } from 'utils/whiteLabel'

export const Text = styled.div`
  color: ${p => p.color ?? '#000'};

  /* Web - H3 */
  font-family: Montserrat;
  font-size: ${p => p.size ?? '14px'};
  font-style: normal;
  font-weight: ${p => p.fontWeight ?? '400px'};
  line-height: ${p => p.height ?? '20px'}; /* 155.556% */
`

export const OrderList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`

export const LinkButton = styled(Link)`
    border-radius: 8px;
    background: ${isWhiteLabel() ? '#000' : 'var(--Orange-0, #F26722)'};
    height: ${ p => p.height ?? '52px'};
    text-decoration: none;

    ${p => p.disabled && `
        opacity: 0.5;
        pointer-events: none;
    `}
`

export const Quantity = styled.div`
    border-radius: 4px;
    background: ${isWhiteLabel() ? '#FFF' : 'var(--Orange--2, #C1521B)'};
    height: 24px;
    width: 24px;
`

export const Divider = styled.div`
    width: 100%;
    height: ${p => p.height ?? '1px'};
    background: ${p => p.color ?? '#666'};
`

export const Description = styled(Text)`
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
`

export const MenuImage = styled.div`
    border-radius: 12px;
    width: 88px;
    height: 88px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: url(${p => p.src}) lightgray 50% / cover no-repeat;
    position: relative;
    padding: 4px;
    display: flex;
    align-items: end;
    justify-content: end;
`

export const AddIcon = styled.div`
    border-radius: 14px;
    background: ${isWhiteLabel() ? '#000' : '#2E9A9A'};
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const BaseLink = styled(Link)`
    cursor: pointer;
    text-decoration: none;
`

export const Select = styled.select`
    border-radius: 8px;
    border: 1px solid #E5E5E5;
    background: var(--Grey-6, #FAFAFA);
`